import { Controller } from "@hotwired/stimulus";

// Copy a string to the clipboard. Set data-clipboard-copy-text-value on the
// element, or fall back to the text of the closest .ui.action.input's input.
//
//   <button data-controller="clipboard-copy"
//           data-clipboard-copy-text-value="https://..."
//           data-action="click->clipboard-copy#copy">Copy</button>
//
// Optionally set data-clipboard-copy-event-value to fire a PostHog capture
// on a successful copy (data-clipboard-copy-event-props-value is a JSON
// object of extra properties). This is how one controller instruments both
// a static button and any copy buttons injected into the page afterward —
// see referral_kit_generations/_assets.html.haml, which reuses this
// controller for cards swapped in after the AI kit generator finishes.
export default class extends Controller {
  static values = {
    text: String,
    doneLabel: { type: String, default: "Copied" },
    event: String,
    eventProps: Object,
  };

  copy(event) {
    event?.preventDefault?.();
    const text =
      this.textValue ||
      this.element
        .closest(".ui.action.input, .clipboard-copy-scope")
        ?.querySelector("input, textarea")?.value;
    if (!text) return;

    navigator.clipboard.writeText(text).then(() => {
      this._flash();
      this._track();
    });
  }

  _flash() {
    const original = this.element.textContent;
    this.element.textContent = this.doneLabelValue;
    setTimeout(() => {
      this.element.textContent = original;
    }, 1500);
  }

  _track() {
    if (!this.hasEventValue || typeof window.posthog === "undefined") return;
    window.posthog.capture(this.eventValue, this.eventPropsValue);
  }
}
